import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import dataService from 'services/dataService';

const fetchData = async (query, cb) => {
  const { data } = await dataService.getList(
    `core/medications/search?query=${query}`,
  );
  return cb(data);
};

const debouncedSearch = debounce(async (string, cb) => {
  fetchData(string, cb);
}, 800);

const useSearch = (query) => {
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const currentResult = results.some(
      (item) => item && item.id.includes(query),
    );
    if (query && query.length > 2 && !currentResult) {
      debouncedSearch(query, (data) => {
        setResults(data.map((item) => ({ id: item, label: item })));
        setIsLoading(false);
      });
      setIsLoading(true);
    } else {
      setResults([]);
    }
  }, [query]);

  return { isLoading, results };
};

export default useSearch;
